import { useState } from "react";
import { NavLink, Link, useNavigate } from "react-router-dom";
import { Menu, LogOut, Shield, Sparkles, X } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";

const LINKS = [
  ["/studio", "Avatar Studio"],
  ["/builder", "Outfit Builder"],
  ["/katalog", "Marken"],
  ["/kleiderschrank", "Kleiderschrank"],
  ["/marktplatz", "Marktplatz"],
  ["/stylist", "KI-Stylist"],
];

const linkCls = ({ isActive }) =>
  `text-[13px] tracking-wide transition-colors duration-200 ${isActive ? "text-[#D4AF37]" : "text-neutral-400 hover:text-[#FAF7F0]"}`;

export default function Header() {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const doLogout = async () => { await logout(); setOpen(false); navigate("/"); };

  return (
    <header className="sticky top-0 z-50 border-b border-white/10 bg-black/70 backdrop-blur-xl" data-testid="site-header">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <Logo />
        <nav className="hidden items-center gap-7 lg:flex">
          {LINKS.map(([to, label]) => (
            <NavLink key={to} to={to} className={linkCls} data-testid={`nav-${to.slice(1)}`}>{label}</NavLink>
          ))}
          {user?.role === "admin" && (
            <NavLink to="/admin" className={linkCls} data-testid="nav-admin"><Shield className="inline h-3.5 w-3.5" /> Admin</NavLink>
          )}
        </nav>
        <div className="hidden items-center gap-3 lg:flex">
          {user ? (
            <>
              <span className="max-w-[140px] truncate text-xs text-neutral-400" data-testid="header-user-name">{user.name}</span>
              <button onClick={doLogout} className="btn-ghost !px-4 !py-2" data-testid="logout-button"><LogOut className="h-4 w-4" /></button>
            </>
          ) : (
            <>
              <Link to="/login" className="text-sm text-neutral-300 hover:text-white" data-testid="header-login-link">Anmelden</Link>
              <Link to="/login?mode=register" className="btn-cream !px-5 !py-2" data-testid="header-register-button"><Sparkles className="h-4 w-4" /> Registrieren</Link>
            </>
          )}
        </div>
        <button className="lg:hidden" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle">
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>
      {open && (
        <div className="border-t border-white/10 bg-[#0A0A0B] px-4 py-6 lg:hidden" data-testid="mobile-menu">
          <div className="flex flex-col gap-4">
            {LINKS.map(([to, label]) => (
              <NavLink key={to} to={to} className={linkCls} onClick={() => setOpen(false)}>{label}</NavLink>
            ))}
            {user?.role === "admin" && <NavLink to="/admin" className={linkCls} onClick={() => setOpen(false)}>Admin</NavLink>}
            {user ? (
              <button onClick={doLogout} className="btn-ghost mt-2" data-testid="mobile-logout-button">Abmelden</button>
            ) : (
              <Link to="/login" onClick={() => setOpen(false)} className="btn-cream mt-2">Anmelden</Link>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
